export default {
    default: {
        options: {
            chart: {
                title: "Response Time"
            },
            height: 300,
            width: 832,
            backgroundColor: { fill:'transparent' },
            chartArea: {width: "80%", height: "90%"},
            explorer: { actions: ['dragToZoom', 'rightClickToReset'] },
            legend: {position: 'none'},
            vAxis: { title: 'Response time in ms'},
            labels: ["Time", "Response Time"],
            roles: ["domain", "data", "scope"]
        },
        type: "LineChart",
        typesavailable: [
            {text: "Line Graph", value: "LineChart" },
            {text: "Area Graph", value: "AreaChart" }
        ],
        labels: ["Time"],
        fields: {
            rt: {
                label: "Response"
            }
        },
        title: "Response Time"
    },
    AGENT: {
        typesavailable: [
            {text: "Line Graph", value: "LineChart" },
            {text: "Area Graph", value: "AreaChart" },
            {text: "Stacked Area Graph", value: "StackedAreaChart" }
        ],
        fields: {
            rt: {
                label: "Response"
            },
            f: true
        }
    },
    CLUSTER: {
        labels: ["Time", "Failing"],
        options: {
            vAxis: { title: "Number of Checks Failing"}
        },
        typesavailable: [
            {text: "Line Graph", value: "LineChart" },
            {text: "Area Graph", value: "AreaChart" },
            {text: "Stepped Area Chart", value: "SteppedAreaChart"},
            {text: "Gauge", value: "Gauge"}
        ]
    },
    HTTPPARSE: {
        typesavailable: [
            {text: "Line Graph", value: "LineChart" },
            {text: "Area Graph", value: "AreaChart" },
            {text: "Stacked Area Graph", value: "StackedAreaChart" },
            {text: "Gauge", value: "Gauge"}
        ],
        fields: {
            rt: {
                label: "Response"
            },
            f: true
        }
    },
    PUSH: {
        typesavailable: [
            {text: "Line Graph", value: "LineChart" },
            {text: "Area Graph", value: "AreaChart" },
            {text: "Stacked Area Graph", value: "StackedAreaChart" },
            {text: "Gauge", value: "Gauge"}
        ],
        fields: {
            f: true
        }
    }
}

/*  Sample config
    {
        type: "AreaChart",
        title: "Disk Free",
        fields: {
            f: {
                'FMC4C7': {label: "Disk Free Data"},
                'FMN7K7': {label: "Disk Free /"}
            }
        }
    }
*/

/*  Check types
AGENT
AUDIO
CLUSTER
DNS
FTP
HTTP
HTTPADV
HTTPCONTENT
HTTPPARSE
IMAP4
MYSQL
NTP
PING
POP3
PORT
PUSH
RBL
RDP
SIP
SMTP
SNMP
SPEC10DNS
SPEC10RDDS
SSH
SSL
WEBSOCKET
WHOIS

CASS
JSONCONTENT
*/